// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e5cd8dee","156":"67825107","236":"cc35d555","337":"75b3d77f","460":"15f23067","593":"294dcbb0","718":"109128ea","735":"b1ef6d88","871":"a33ba373"}[chunkId] + ".chunk.js";
};